import { convertFormDataToFilesJson } from './generics-conversion-service';
var convertFormDataToAbstractCreateRequest = function convertFormDataToAbstractCreateRequest(data) {
  return {
    files: convertFormDataToFilesJson(data),
    styleOfEnglish: data.styleOfEnglish,
    origin: 'aje',
    abstractType: data.abstractType,
    wordLimitMin: data.wordCountRange[0],
    wordLimitMax: data.wordCountRange[1],
    includeSimpleSummary: data.additionalOutputs.simpleLanguageSummary ? 'true' : 'false',
    includeGraphicalAbstract: data.additionalOutputs.graphicalAbstract ? 'true' : 'false'
  };
};
export default convertFormDataToAbstractCreateRequest;